// extracted by mini-css-extract-plugin
module.exports = {"arrow":"dd31006766--arrow--Uhc4v","arrow-left":"dd31006766--arrow-left--SJM6U"};